import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { createCheckoutSession } from '../api.js'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '../analytics.js'

export default function PaywallModal({ onClose, price, source }) {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [agreedToTerms, setAgreedToTerms] = useState(false)

  useEffect(() => {
    trackEvent('paywall_opened', { source })
  }, [source])

  const formattedPrice = price
    ? (price.amount / 100).toLocaleString(undefined, { style: 'currency', currency: price.currency })
    : '…'

  const features = t('paywall.features', { returnObjects: true })
  const featureList = Array.isArray(features)
    ? features
    : t('paywall.features', { returnObjects: true, lng: 'en' })

  async function handleSubscribe() {
    trackEvent('subscription_intent', { currency: price?.currency ?? 'USD' })
    setLoading(true)
    setError('')
    try {
      const { data } = await createCheckoutSession()
      window.location.href = data.checkout_url
    } catch {
      setError(t('paywall.error'))
      setLoading(false)
    }
  }

  return (
    <div className="paywall-backdrop" onClick={onClose} aria-hidden="true">
      <div
        className="paywall-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="paywall-title"
      >
        <button className="paywall-close" onClick={onClose} aria-label="Close">✕</button>
        <div className="paywall-plan-label">{t('paywall.plan')}</div>
        <div className="paywall-price-row" id="paywall-title">
          <span className="paywall-price-amount">{formattedPrice}</span>
          <span className="paywall-price-period">{t('paywall.perMonth')}</span>
        </div>
        <hr className="paywall-divider" />
        <div className="paywall-features-heading">{t('paywall.featuresHeading')}</div>
        <ul className="paywall-features">
          {featureList.map((f) => (
            <li key={f}><span className="paywall-check">&#10003;</span>{f}</li>
          ))}
        </ul>
        <hr className="paywall-divider" />
        {error && <div className="paywall-error">{error}</div>}
        <label className="terms-checkbox-label">
          <input
            type="checkbox"
            className="terms-checkbox"
            checked={agreedToTerms}
            onChange={(e) => setAgreedToTerms(e.target.checked)}
          />
          <span className="terms-checkbox-text">
            {t('dashboard.agreeCheckbox')}{' '}
            <Link to="/terms" className="dash-legal-link">{t('legal.termsOfService')}</Link>
            {' '}{t('dashboard.agreeAnd')}{' '}
            <Link to="/privacy" className="dash-legal-link">{t('legal.privacyPolicy')}</Link>
          </span>
        </label>
        <button
          className="paywall-subscribe-btn"
          onClick={handleSubscribe}
          disabled={loading || !agreedToTerms}
          autoFocus
        >
          {loading ? t('paywall.redirecting') : t('paywall.subscribe')}
        </button>
        <div className="paywall-no-commitment">{t('paywall.noCommitment')}</div>
      </div>
    </div>
  )
}
